const deleteReqMaker = locations => {
  const toDeleteLocations = locations.filter(location => {
    return location.toDelete === true
  })

  return toDeleteLocations.map(location => {
    return {
      raw: location,
      serialized: {
        id: location.id,
        deleted: true,
      },
    }
  })
}

export default deleteReqMaker
